module.exports = __webpack_public_path__ + "static/img/3.ebb94ed.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/3/sp/3.png
// module id = J4/z
// module chunks = 0